import { render, staticRenderFns } from "./DSimpleCheckboxPreview.vue?vue&type=template&id=53acae78&"
import script from "./DSimpleCheckboxPreview.vue?vue&type=script&lang=js&"
export * from "./DSimpleCheckboxPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports